// Single source of truth for API and WebSocket URLs.
// VITE_API_URL and VITE_WS_URL are set in src/ui/.env.
// AUTH_BACKEND is always the same as BACKEND (no separate auth origin).
//
// In development, the browser always uses relative paths (empty base) so all
// requests flow through the Vite dev proxy. The proxy target is set in
// vite.config.ts via loadEnv() and reads VITE_API_URL from .env.
// This avoids CORS issues — the browser never calls the remote API directly.
//
// In production builds, VITE_API_URL is the full public API URL that the
// browser calls directly (no Vite proxy in production).
export const apiBaseUrls = {
  BACKEND: import.meta.env.DEV ? "" : (import.meta.env.VITE_API_URL ?? ""),
  WS: import.meta.env.DEV ? "" : (import.meta.env.VITE_WS_URL ?? ""),
};

export const endpoints = {};

const links = {};

export default links;

export const ws_endpoints = {
  delete_project_status: "delete_project_status",
  delete_application_status: "delete_application_status",
  application_deployment_status: "deployment_status",
  application_status: "application_status",
};
